import { useState } from 'react';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import useGuide from '../../hooks/useGuide';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '../../helper/classNames';
import SharingModal from '../../pages/Game/components/SharingModal';

type Props = {
  gameId: string;
};

const InviteButton = ({ gameId }: Props) => {
  const [showSharingModal, setShowSharingModal] = useState(false);
  const { finishAnimation, getCurrentAnimationClass } = useGuide([
    'invite-player',
  ]);

  const hasClickedInvite =
    sessionStorage.getItem('hasClickedInvite') === 'true';

  const openSharingModal = () => setShowSharingModal(true);
  const closeSharingModal = () => setShowSharingModal(false);

  const handleClick = () => {
    if (!hasClickedInvite) {
      finishAnimation('invite-player');
      sessionStorage.setItem('hasClickedInvite', 'true');
    }
    openSharingModal();
  };

  return (
    <>
      <button
        aria-label="Öffne Sharing Menü"
        onClick={handleClick}
        className="grid h-9 w-9 place-items-center"
      >
        <span
          className={classNames(
            'grid h-7 w-7 rounded-md place-items-center',
            !hasClickedInvite && getCurrentAnimationClass('invite-player')
          )}
        >
          <FontAwesomeIcon icon={faUserPlus} className="w-6 h-6" />
        </span>
      </button>
      <SharingModal
        gameId={gameId}
        show={showSharingModal}
        close={closeSharingModal}
      />
    </>
  );
};

export default InviteButton;
